<template lang="pug">
  b-card.gl-404(:class="{ 'no-border': options.border === 'none' }" :title="options.message")
</template>

<script>
export default {

  // props
  props: {
    options: Object
  }
}
</script>

<style lang="scss">
  @import '../styles/colors';

  .gl-404 {

    .card-title {
      color: $gl-grey;
      margin: 0;
      font-size: 18px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/gl-404.vue